import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './single-column-section-card.module.scss';

type Props = {
  displayCard?: boolean;
  pdp?: boolean;
};

export const SingleColumnSectionCard = ({
  children,
  displayCard = true,
  pdp = false,
}: PropsWithChildren<Props>) => {
  if (!displayCard) return <>{children}</>;

  return (
    <div
      className={classNames(styles.singleColumnSectionCardRoot, {
        [styles.pdp]: pdp,
      })}
    >
      {children}
    </div>
  );
};
